import { StepJsonTypeEnum } from "../enums";
import { ActorProfile, ActorProfileMaster, InboxDetailType } from "../types";

const hasValidActorId = (value: unknown): boolean => {
    return value !== null && value !== undefined && value !== "" && value !== -1 && value !== "-1";
};

export const isManager = (type?: string) => {
    if (!type) return false;

    switch (type) {
        case StepJsonTypeEnum.ASSIGNED_MANAGER:
            return true;
        case StepJsonTypeEnum.EMPLOYEE_NAME:
        case StepJsonTypeEnum.EMPLOYEE_SELF:
            return false;
        default:
            return false;
    }
};

export const isManagerV2 = (notificationDetail?: InboxDetailType, osEmpAccountId?: string) => {
    if (!notificationDetail || !osEmpAccountId) return false;

    const managerId = notificationDetail.shiftTransaction?.manager?.os_emp_account_id;

    return managerId == osEmpAccountId;
};

export const isManagerOrOwner = (user?: ActorProfileMaster | null): boolean => {
  if (!user) return false;
  return Boolean(
    (user as any).is_manager ||
    (user as any).is_account_owner ||
    (user as any).isManager
  );
};

export const getPrimaryActorId = (user?: Partial<ActorProfileMaster> | null): string | number | null => {
    if (!user) {
        return null;
    }

    const employeeId = (user as any).id ?? (user as any).os_emp_account_id;
    if (hasValidActorId(employeeId)) {
        return employeeId as string | number;
    }

    const isAccountOwner = (user as any).is_account_owner === true;
    const accountId = (user as any).userAccountId ?? (user as any).user_account_id;

    if (isAccountOwner && hasValidActorId(accountId)) {
        return accountId as string | number;
    }

    return null;
};

export const GetUserFullName = (employee: ActorProfile) => {
    return `${employee?.os_emp_first_name || employee?.osEmpFirstName} ${
        employee?.os_emp_last_name || employee?.osEmpLastName
    }`;
};
